export default "__VITE_ASSET__93747989__"